import { Pipe, PipeTransform } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Pipe({
    name: 'zipcodeIsValid',
    pure: false
})
export class PipeZipcodeIsValid implements PipeTransform {
    transform(formGroup:FormGroup): any {
        const value = formGroup.controls['addressZipcode']?.value || null;
        return value == null? false : value.replace('-', '').replace('.', '').length == 8;
        
    }
}